module.exports = __webpack_public_path__ + "static/media/btn_menu.1841a74a.svg";